import { useTranslation } from "react-i18next";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ConvertToString from "../../../../components/Converter";

function PileDiameter({ value }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionMicropiles.pileDiameter")}</p>}
      inputValue={<span className="input">{ConvertToString(value, 0)}</span>}
      unitValue={<span>mm</span>}
      indicesValue={
        <span>
          D<sub>c</sub>
        </span>
      }
    />
  );
}

export default PileDiameter;
